import { useEffect, useState } from "react";
import EntrepriseServices from "../../services/entreprise/entrepriseServices";

function useEntreprises() {
  const [entreprises, setEntreprises] = useState([]);

  function fetchEntreprises() {
    return EntrepriseServices.getAll()
      .then((res) => {
        if (Array.isArray(res.data.data)) {
          setEntreprises(res.data.data);
        } else {
          console.error("La réponse de l'API n'est pas un tableau.");
        }
      })
      .catch((err) => console.error("Erreur API :", err));
  }

  function getAllEntreprises() {
    return EntrepriseServices.getAll();
  }


  const getOneEntreprise = (id, callback = () => { }) => {
    EntrepriseServices.getOne(id)
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => console.error(err));
  };


  const createEntreprise = (data, callback = () => { }) => {
    EntrepriseServices.create(data)
      .then(() => {
        fetchEntreprises();
        callback();
      })
      .catch((err) => console.error(err));
  };


  const updateEntreprise = (id, data, callback = () => { }) => {
    EntrepriseServices.update(id, data)
      .then(() => {
        fetchEntreprises();
        callback();
      })
      .catch((err) => console.error(err));
  };

  const deleteEntreprise = (id, callback = () => { }) => {
    EntrepriseServices.delete(id)
      .then(() => {
        fetchEntreprises();
        callback();
      })
      .catch((err) => console.error(err));
  };

  return { entreprises, createEntreprise, updateEntreprise, deleteEntreprise, fetchEntreprises, getAllEntreprises };
}

export default useEntreprises;
